import { useMemo } from "react";
import { ImageNode } from "@noli/core";
import { useTranslate } from "@/utils/lang";
import { Editor_Words } from "@/utils/lang/editor";
import { useSelectImages } from "./useSelectImages";

type PostableNodeTypes = "image" | "group" | "multiple";
// 可以发布的节点类型
const POSTABLE_TYPES: PostableNodeTypes[] = ["image", "group", "multiple"];
export interface PostWorkDataType {
  imageNodes: ImageNode[];
  msg: string;
  continue: boolean;
}
function usePostWork(): PostWorkDataType {
  const { translate } = useTranslate();
  const { imageNodes, originImageNodes, originNodes } = useSelectImages({
    maxCount: 9,
    selectType: POSTABLE_TYPES,
  });
  const result = useMemo(() => {
    if (originNodes?.length) {
      const postWorkData: PostWorkDataType = {
        msg: "",
        continue: false,
        imageNodes,
      };

      if (!originImageNodes.length) {
        postWorkData.msg = translate(
          Editor_Words["message_post-only-support-image-and-select-again"],
        );
      }

      if (originImageNodes.length > 0) {
        if (originImageNodes.length < originNodes.length) {
          postWorkData.msg = translate(Editor_Words["message_post-only-support-image"]);
        }

        if (originImageNodes.length > 9) {
          postWorkData.msg = translate(Editor_Words["message_post-max-count-and-select-again"]);
          postWorkData.continue = false;
        }

        if (originImageNodes.length <= 9) {
          postWorkData.continue = true;
        }
      }
      return postWorkData;
    }

    return {
      imageNodes: [],
      msg: translate(Editor_Words["message_post-select"]),
      continue: false,
    };
  }, [imageNodes, originImageNodes, originNodes]);

  return result;
}

export default usePostWork;
